var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import cl from "clsx";
import React, { forwardRef } from "react";
import { XMarkIcon } from "@navikt/aksel-icons";
import { composeEventHandlers } from "../util/composeEventHandlers.js";
export const RemovableChips = forwardRef((_a, ref) => {
    var { className, children, variant = "action", removeLabel = "slett", onDelete, type = "button", onClick } = _a, rest = __rest(_a, ["className", "children", "variant", "removeLabel", "onDelete", "type", "onClick"]);
    return (React.createElement("button", Object.assign({}, rest, { ref: ref, type: type, className: cl("navds-chips__chip navds-chips__removable navds-chips--icon-right", className, `navds-chips__removable--${variant}`), "aria-label": `${children} ${removeLabel}`, onClick: composeEventHandlers(onClick, onDelete) }),
        React.createElement("span", { className: "navds-chips__chip-text" }, children),
        React.createElement("span", { className: "navds-chips__removable-icon" },
            React.createElement(XMarkIcon, { "aria-hidden": true }))));
});
export default RemovableChips;
//# sourceMappingURL=Removable.js.map